var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenticBgElement1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 196.91 497.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .4;\n        stroke: #3e83bb;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 196.91,
    height: 497.42
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "die_line",
    "data-name": "die line"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -523.7,
    y: -206.08,
    width: 628.65,
    height: 628.65,
    rx: 43.35,
    ry: 43.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -490.67,
    y: -178.21,
    width: 628.65,
    height: 628.65,
    rx: 43.35,
    ry: 43.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -450.41,
    y: -148.79,
    width: 628.65,
    height: 628.65,
    rx: 43.35,
    ry: 43.35
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenticBgElement1);
export default __webpack_public_path__ + "static/media/rentic_bg_element1.827aa636bb3fa668cb37390884f941b3.svg";
export { ForwardRef as ReactComponent };